import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import IconButton from '../../common/IconButton';

const NavTab = ({ onChange, items, currentTab }) => {
  const [activeTab, setActiveTab] = useState(currentTab);

  useEffect(() => {
    setActiveTab(items.indexOf(items.filter(i => i.value === currentTab)[0]));
  }, [currentTab]);

  return (
    <div className="nav-tab">
      {items.map((item, i) => (
        <div
          key={item.id}
          role="presentation"
          className={`nav-tab_button ${activeTab === i &&
            'nav-tab_button-selected'} 
 
          `}
          onClick={() => {
            setActiveTab(i);
            onChange(i);
          }}
        >
          <IconButton
            label={item.label}
            // disabled={i >= 1}
            backgroundColor="#000"
            icon={item.icon}
            iconColor="#fff"
          />
        </div>
      ))}
    </div>
  );
};

NavTab.propTypes = {
  onChange: PropTypes.func,
  items: PropTypes.array,
  currentTab: PropTypes.string
};

export default NavTab;
